/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NonceChallengeOptions
 */
export interface NonceChallengeOptions {
    /**
     * 
     * @type {string}
     * @memberof NonceChallengeOptions
     */
    challenge?: string;
}

/**
 * Check if a given object implements the NonceChallengeOptions interface.
 */
export function instanceOfNonceChallengeOptions(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function NonceChallengeOptionsFromJSON(json: any): NonceChallengeOptions {
    return NonceChallengeOptionsFromJSONTyped(json, false);
}

export function NonceChallengeOptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): NonceChallengeOptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'challenge': !exists(json, 'challenge') ? undefined : json['challenge'],
    };
}

export function NonceChallengeOptionsToJSON(value?: NonceChallengeOptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'challenge': value.challenge,
    };
}

